import { createState, useState } from '@hookstate/core';
import { IDispatchRelated } from '../interfaces/IDispatchRelated';
import { authFetch } from '~/services/fetch';

const dispatchRelatedState = createState<IDispatchRelated | object>({});

interface defaultActions {
  readonly loading: boolean,
  readonly retryConnect: boolean,
}

const defaultActions: defaultActions = {
  loading: false,
  retryConnect: false,
}

const defaultActionsDefaultState = createState<defaultActions>(Object.create(defaultActions))


const useDispatchRelatedState = () => {
  const dispatchRelated = useState(dispatchRelatedState);
  const defaultActionsState = useState(defaultActionsDefaultState)
  const loading = useState(defaultActionsState.loading)
  const retryConnect = useState(defaultActionsState.retryConnect)

  function setDefaultdispatchRelated() {
    dispatchRelated.set({})
  }

  return ({
    dispatchRelated: () => dispatchRelated,
    updateStatusRelated: ({ dispatchId, status }) => {
      try {
        if (dispatchRelated[dispatchId].get()) {
          dispatchRelated[dispatchId].status.set(status);
        }
        return true
      } catch (error) {
        console.error(`Despacho sem objeto de status: ${JSON.stringify(dispatchRelated[dispatchId])} `);
        return false
      }
    },
    loading: () => loading,
    retryConnect: () => retryConnect,
    syncRelatedDispatches: async (dispatchId: string | number | null) => {
      // retryConnect.set(false)
      loading.set(true)
      setDefaultdispatchRelated();
      
      if (!dispatchId) {
        loading.set(false)
        return false;
      }
      
      try {
        const { data } = await authFetch({
          url: '/dispatch/all-from-occurrence',
          method: 'POST',
          data: {
            'dispatch_id': dispatchId
          }
        })
        
        if (!data) {
          setDefaultdispatchRelated();
          return false
        }

        const dispatches = data.reduce(function (target, key) {
          return {
            ...target,
            [key.id]: key
          }
        }, {})
        
        dispatchRelated.set(dispatches);
        return true
      } catch (error) {
        console.error('Erro ao sincronizar despachos relacionados:', error)
        setDefaultdispatchRelated();
        return false
      } finally {
        loading.set(false)
      }
    },
    updateDispatchesRelated: ({id, code, status}) => {
      dispatchRelated.merge({
        [id]: {
          id: id,
          code: code,
          status: status
        }
      })
    },
    setDefaultdispatchRelated: setDefaultdispatchRelated,
  })
}

export default useDispatchRelatedState;